// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuLabel_root__D4DoI","clickedWithMouse":"MenuLabel_clickedWithMouse__3EJUE","isOpen":"MenuLabel_isOpen__3p9HE"};